/**
 * @generated SignedSource<<43f19697759d9e7d6bd573958bc13de2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RowMaybeWithDragAndDrop_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RowInner_project" | "RowWithDragAndDrop_project">;
  readonly " $fragmentType": "RowMaybeWithDragAndDrop_project";
};
export type RowMaybeWithDragAndDrop_project$key = {
  readonly " $data"?: RowMaybeWithDragAndDrop_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"RowMaybeWithDragAndDrop_project">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "isConditionalFormattingEnabled",
    "variableName": "isConditionalFormattingEnabled"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "RowMaybeWithDragAndDrop_project",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "RowWithDragAndDrop_project"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "RowInner_project"
    }
  ],
  "type": "JiraProject"
};
})();

(node as any).hash = "7b2fa8240809ed877a350cb43191a25e";

export default node;
